import { SLIDES_PER_VIEW_DEFAULT_VALUE } from '../constants';
export const getSlidesPerView = slider => {
  if (typeof slider?.slides === 'object') {
    const value = typeof slider.slides?.perView === 'function' ? slider.slides.perView() : slider.slides?.perView;
    return typeof value === 'number' ? value : SLIDES_PER_VIEW_DEFAULT_VALUE;
  }
  return SLIDES_PER_VIEW_DEFAULT_VALUE;
};
//# sourceMappingURL=getSlidesPerView.js.map